import { caseStudiesData } from './caseStudiesData';
import { CaseStudy } from './types';

/**
 * Case Study Registry
 * 
 * This registry maps case study slugs to their data and template type.
 * Use this to:
 * - Get a case study by slug
 * - List all case studies
 * - Check which template to render for a case study
 */

export const caseStudyRegistry = {
  /**
   * Get a case study by slug
   */
  getBySlug: (slug: string): CaseStudy | undefined => {
    return caseStudiesData.find((cs: CaseStudy) => cs.metadata.slug === slug);
  },

  /**
   * Get a case study by ID
   */
  getById: (id: string): CaseStudy | undefined => {
    return caseStudiesData.find((cs: CaseStudy) => cs.metadata.id === id);
  },

  /**
   * Get all case studies
   */
  getAll: (): CaseStudy[] => {
    return caseStudiesData;
  },

  /**
   * Get all case studies for a specific template
   */
  getByTemplate: (template: 1 | 2): CaseStudy[] => {
    return caseStudiesData.filter(cs => cs.metadata.template === template);
  },

  /**
   * Get all case study slugs
   */
  getAllSlugs: (): string[] => {
    return caseStudiesData.map(cs => cs.metadata.slug);
  },

  /**
   * Get all case study IDs
   */
  getAllIds: (): string[] => {
    return caseStudiesData.map(cs => cs.metadata.id);
  },
};

